import { render } from "./StudentDataBlock.vue?vue&type=template&id=76ea8c9e"
import script from "./StudentDataBlock.vue?vue&type=script&lang=js"
export * from "./StudentDataBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__